/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { useContext, useEffect, useRef, useState } from "react";
import sass from "./listCurrentThread.module.sass";
import Badge from "components-new/Badge";
import PortalWrapper from "components-new/PortalWrapper";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import { CreateContext } from "pages/StepPages/StepFour/One/Tables/Tables";
import { ReactComponent as ActionMenuIcon } from "images/ActionMenuIcon.svg";
import { useOutsideAlerter } from "hooks/useOutsideAlerter";
import DropMenu from "pages/StepPages/StepFour/One/Tables/TableNavigate/DropMenu";
import { useAnimate } from "components-new/AnimateTemp/AnimateTemp";
import { fetchActualTableData } from "pages/StepPages/StepFour/One/Tables/fetch";
import { useParams } from "react-router-dom";
import { ReactComponent as LoadingIcon } from "images/load.svg";
import parentSass from "../nav.module.sass";
import { snackWrapper } from "helpers";
import { ChangeActiveTabContext } from "../TableNavigate";
import { organizationAPI } from "libs/apiClient/Organization";
import { ActualThreatResponse } from "libs/apiClient/data-contracts";
import ListCurrentThreatModal from "pages/StepPages/StepFour/One/Tables/TableNavigate/ListCurrentThreatsTable/ListCurrentThreatModal";

interface IModal {
	data: ActualThreatResponse | null;
	active: "create" | "edit" | null;
}

interface IRowProps {
	index: number;
	data: ActualThreatResponse;
	modal: () => void;
	setData: (index: number) => void;
}

const Row: React.FC<IRowProps> = ({ data, index, modal, setData }) => {
	const { confirm, openConfirm } = useContext(CreateContext);
	const { updateTabs } = useContext(ChangeActiveTabContext);
	const [target, setTarget] = useState<HTMLOrSVGElement | undefined>();
	const toggleTarget = (e: React.MouseEvent<HTMLOrSVGElement>) => {
		e.stopPropagation();
		target ? setTarget(undefined) : setTarget(e.currentTarget);
	};

	const { handleClose, className } = useAnimate({
		unMount: parentSass.close,
		mount: parentSass.open,
		// unMount:sass.open,
		// mount:sass.close,
		delay: 200,
		firstUnMount: true,
	});

	useOutsideAlerter(target, () => setTarget(undefined));
	const removeItem = () => {
		if (confirm) {
			openConfirm();
			return;
		}
		if (target) {
			organizationAPI.objectThreatsActualDelete(+target.dataset.id!).then(() => {
				snackWrapper("success", "Запись успешно удалена");
				updateTabs("ACTUAL");
				handleClose(() => setData(Number(target.dataset.id)));
			});
		}
	};

	return (
		<>
			<DropMenu click={removeItem} target={target} />
			<tr
				onClick={() => {
					confirm ? openConfirm() : modal();
				}}
				className={className}>
				<td>
					<div>{index}</div>
				</td>
				<td>
					<div>{data.ubi}</div>
				</td>
				<td>
					<div>{data.ubiName}</div>
				</td>
				<td>
					<div>{data.description}</div>
				</td>
				<td>
					<div>{data.sourceText ? data.sourceText : <span dangerouslySetInnerHTML={{ __html: "&mdash;" }} />}</div>
				</td>
				<td>
					<div>{data.influence}</div>
					{data.systemMeans && (
						<>
							<br />
							<p>Технические средства:</p>
							{data.systemMeans && (
								<div className={sass.badgeGroup}>
									{data.systemMeans.map((_, index) => (
										<React.Fragment key={index}>
											<Badge color={"#C78300"}>{_}</Badge>
										</React.Fragment>
									))}
								</div>
							)}
						</>
					)}
				</td>
				<td>
					<div style={{ display: "flex", gap: 4, alignItems: "center", flexWrap: "wrap" }}>
						{data.tacticTechnic?.length ? (
							data.tacticTechnic.map((_, index) => (
								<React.Fragment key={index}>
									<Badge color={"#005B9B"}>{_}</Badge>{" "}
								</React.Fragment>
							))
						) : (
							<span dangerouslySetInnerHTML={{ __html: "&mdash;" }} />
						)}
					</div>
				</td>
				<td>
					<div className={sass.badgeGroup}>
						{!data.privacy && !data.integrity && !data.availability && (
							<span dangerouslySetInnerHTML={{ __html: "&mdash;" }} />
						)}
						{data.privacy && <Badge type={"warn"}>К</Badge>}
						{data.integrity && <Badge type={"error"}>Ц</Badge>}
						{data.availability && <Badge type={"success"}>Д</Badge>}
					</div>
				</td>
				<td>
					<div>
						<ActionMenuIcon data-id={data.id} onClick={toggleTarget} />
					</div>
				</td>
			</tr>
		</>
	);
};

const ListCurrentThreatsTable = () => {
	const { container, actual, setConfirm, currentThread, confirm, openConfirm, selectFile, checkTables } =
		useContext(CreateContext);

	const { updateTabs } = useContext(ChangeActiveTabContext);

	useEffect(() => {
		if (actual && actual.length) {
			setData(actual);
			updateTabs("ACTUAL");
		}
		//eslint-disable-next-line
	}, [actual]);

	const [load, setLoad] = useState(false);

	const [modal, setModal] = useState<IModal>({ data: null, active: null });

	const [data, setData] = useState<ActualThreatResponse[]>([]);

	const params = useParams();

	useEffect(() => {
		setLoad(true);
		fetchActualTableData(Number(params.threadId))
			.then((actual) => {
				setLoad(false);
				setData(actual);
			})
			.catch(() => setLoad(false));
		//eslint-disable-next-line
	}, []);

	useEffect(() => {
		setConfirm((prevState: any) => ({ ...prevState, actual: data }));
		//eslint-disable-next-line
	}, [data]);

	const removeItem = (id: number) => {
		setData([...data].filter((_) => _.id !== id));
	};

	const ref = useRef<HTMLInputElement>(null);

	return (
		<div className={sass.wrapper}>
			<ListCurrentThreatModal
				toggle={modal.active}
				data={data}
				active={modal.data}
				close={() => setModal({ data: null, active: null })}
				replace={(_) => {
					setData(_);
				}}
			/>
			{container?.current && (
				<PortalWrapper containerRef={container.current}>
					<input
						ref={ref}
						accept={".docx, application/pdf"}
						onChange={(e) => {
							selectFile(e);
						}}
						id={"file"}
						type={"file"}
						disabled={currentThread?.threatStatus === "APPROVED"}
						hidden={true}
					/>
					<Button
						onClick={() => {
							checkTables({
								type: "model",
								ok: () => {
									ref.current?.click();
								},
							});
						}}
						disabled={currentThread?.threatStatus === "APPROVED"}
						variant={BUTTON_VARIANTS.OUTLINED}>
						Загрузить утвержденный документ
					</Button>
					<Button
						variant={BUTTON_VARIANTS.CONTAINED}
						onClick={() => {
							confirm ? openConfirm() : setModal({ data: null, active: "create" });
						}}>
						Добавить информацию
					</Button>
				</PortalWrapper>
			)}
			<div className={sass.sticky}>
				<div className={sass.caption}>Таблица 9 – Перечень актуальных угроз безопасности информации</div>
				<table>
					<thead>
						<tr>
							<th>Номер</th>
							<th>Уби</th>
							<th>Наименование уби</th>
							<th>Описание</th>
							<th>источник угрозы</th>
							<th>Объект воздействия</th>
							<th>Тактики и техники реализации угроз</th>
							<th>Негативные последствия</th>
							<th />
						</tr>
					</thead>
				</table>
			</div>
			<div data-comment-false={true} className={sass.scroll_wrapper}>
				{load ? (
					<LoadingIcon width={50} height={50} className={parentSass.loading} />
				) : (
					<div className={sass.scroll}>
						<table>
							<tbody>
								{data.map((_, index) => {
									return (
										<Row
											key={index}
											index={index + 1}
											data={_}
											modal={() => {
												setModal({ data: _, active: "edit" });
											}}
											setData={removeItem}
										/>
									);
								})}
							</tbody>
						</table>
					</div>
				)}
			</div>
		</div>
	);
};

export default ListCurrentThreatsTable;
